export const footerString = 'Ingeniería de Procesos y Producto, I-MAS S.L. / VAT: ESB63729495 /\nR.M. Barcelona, Tomo 37211, Sección general, Folio 0001, Hoja/Dup. 302906'

export const footerWebsite = 'www.protoandgo.com'
